import { Reset } from "@bluframe/blublocks"
import styled from "styled-components"

export const StoreLinks = styled.div`
  display: grid;
  row-gap: 20px;
`

export const StoreLinksControls = styled.div`
  align-items: center;
  display: grid;
  grid-auto-flow: column;
  column-gap: 12px;
  row-gap: 8px;
  justify-content: flex-end;
`

export const StoreLinksUl = styled(Reset.Ul)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
  row-gap: 10px;
`

export const StoreLink = styled.div`
  display: grid;
  row-gap: 10px;
`

export const GuardrailModalContent = styled.div`
  display: grid;
  row-gap: 16px;
`

export const GuardrailActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`
